import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class CountryScoreService {
  static getList(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='',encodedUrlParam) {
    return HttpUtil.get(API_ROUTES.COUNTRYSCORE.LIST.replace("<encodedUrlParam>", encodedUrlParam)
    .replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key));
  }

  static onSubmit(encodedUrlParam,params) {
    var url = API_ROUTES.COUNTRYSCORE.SUBMIT.replace("<encodedUrlParam>", encodedUrlParam);
    return HttpUtil.post(url,params);    
  }

  static deleteData(encodedUrlParam,id) {
    var url = API_ROUTES.COUNTRYSCORE.DELETE.replace("<encodedUrlParam>", encodedUrlParam)
    .replace("<id>", id);
    return HttpUtil.delete(url);    
  }
 
}